import { render } from "./ArchivoSelect.vue?vue&type=template&id=28cd9fee"
import script from "./ArchivoSelect.vue?vue&type=script&lang=js"
export * from "./ArchivoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__